
import * as React from 'react'
import { Image, Text, View, TouchableOpacity, ScrollView, ActivityIndicator, Platform, AppState } from 'react-native'
import images from '../../assets/images'
import { useTheme } from '@react-navigation/native'
import moment from 'moment'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import Axios from 'axios'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { RefreshControl } from 'react-native-web-refresh-control'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import * as Updates from 'expo-updates'
import { showMessage } from "react-native-flash-message"

export default React.memo(function TabHome({ navigation, route }) {
    const { colors } = useTheme()
    const insets = useSafeAreaInsets()
    const [day_string, setDayString] = React.useState(moment().format('DD/MM/YYYY'))
    const [data, setData] = React.useState()
    const [list_merchant, setListMerchant] = React.useState()
    const [merchant, setMerchant] = React.useState()
    const [refreshing, setRefreshing] = React.useState(true)
    const [update_available, setUpdateAvailable] = React.useState(false)
    const appState = React.useRef(AppState.currentState)

    React.useEffect(() => {
        Axios.get(`/api/ceo/home_page?day=${moment().format('YYYY-MM-DD')}`)
            .then(res => {
                console.log(res)
                if (res.status === 200 && res.data.data)
                    setData(res.data.data)
                setRefreshing(false)
            })
            .catch(err => {
                setRefreshing(false)
                console.log(err)
            })
        const restoreState = async () => {
            try {
                const tmp = await AsyncStorage.getItem('list_merchant')
                let list = null
                if (tmp) list = JSON.parse(tmp)
                setListMerchant(list)
                const tmp_ = await AsyncStorage.getItem('merchant')
                let item = null
                if (tmp_) item = JSON.parse(tmp_)
                setMerchant(item)
                if (Platform.OS !== 'web') {
                    const update = await Updates.checkForUpdateAsync()
                    if (update.isAvailable) setUpdateAvailable(true)
                }
            } catch (error) {
                console.log(error)
            }
        }
        if (!list_merchant) {
            restoreState()
        }
        AppState.addEventListener("change", _handleAppStateChange);
        return () => {
            AppState.removeEventListener("change", _handleAppStateChange);
        };
    }, [])

    const _handleAppStateChange = async (nextAppState) => {
        if (
            appState.current.match(/inactive|background/) &&
            nextAppState === "active"
        ) {
            if (Platform.OS !== 'web') {
                console.log('check')
                const update = await Updates.checkForUpdateAsync()
                if (update.isAvailable) setUpdateAvailable(true)
            }
            console.log("App has come to the foreground!")
        }
        appState.current = nextAppState;
        console.log("AppState", appState.current);
    }

    React.useEffect(() => {
        setData(null)
        if (route.params?.day) {
            setDayString(moment(route.params?.day, 'YYYY-MM-DD').format('DD/MM/YYYY'))
            Axios.get(`/api/ceo/home_page?day=${route.params?.day}`)
                .then(res => {
                    console.log(res)
                    if (res.status === 200 && res.data.data)
                        setData(res.data.data)
                    setRefreshing(false)
                })
                .catch(err => {
                    setRefreshing(false)
                    console.log(err)
                })
        }
    }, [route.params?.day])

    const onRefresh = () => {
        setRefreshing(true)
        Axios.get(`/api/ceo/home_page?day=${moment(day_string, 'DD/MM/YYYY').format('YYYY-MM-DD')}`)
            .then(res => {
                console.log(res)
                if (res.status === 200 && res.data.data) {
                    setData(res.data.data)
                }
                setRefreshing(false)
            })
            .catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }

    const getColorText = (value) => {
        try {
            if (value < 50) return colors.text_red
            else if (value < 75) return colors.text_yellow
            else return colors.text_green
        } catch (error) {
        }
    }

    const updateCode = async () => {
        showMessage({ message: "Vui lòng đợi!", description: "Hệ thống đang nâng cấp phiên bản mới", type: "info" })
        await Updates.fetchUpdateAsync()
        await Updates.reloadAsync()
    }

    return (
        <View style={{ flex: 1 }}>
            <View style={{ backgroundColor: merchant?.color, paddingTop: insets.top }}>
                <View style={{
                    paddingHorizontal: 16, alignItems: 'center', paddingVertical: 12,
                    flexDirection: 'row', justifyContent: 'center', backgroundColor: merchant?.color
                }}>
                    <TouchableOpacity onPress={() => navigation.navigate('ModalMerchant', { list_merchant: list_merchant })}
                        style={{ flex: 1, flexDirection: 'row', alignItems: 'center' }}>
                        <Image source={images.icons.icon_setting} style={{ width: 18, height: 18 }} />
                        <View style={{ marginLeft: 11, flex: 1 }}>
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', }}>HAIVAN+ xin chào,</Text>
                        </View>
                    </TouchableOpacity>
                    <View>
                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{day_string}</Text>
                    </View>
                </View>
            </View>

            <ScrollView refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor={colors.text} colors={[colors.text]} />}>
                {
                    data ? <>
                        <View style={{ justifyContent: 'center', alignItems: 'center', marginTop: 13, marginBottom: 8 }}>
                            {
                                update_available ? <TouchableOpacity style={{
                                    backgroundColor: 'white', borderRadius: 4, flexDirection: 'column',
                                    alignItems: 'center', padding: 10
                                }} onPress={updateCode}>
                                    <MaterialCommunityIcons name="cloud-upload-outline" size={24} color="black" />
                                    <Text style={{ fontSize: 12, fontFamily: 'Nunito_700Bold' }}>CẬP NHẬT BẢN MỚI</Text>
                                </TouchableOpacity> :
                                    <Image source={{ uri: merchant?.icon_url }} style={{ height: 60, width: '100%' }} resizeMode='contain' />
                            }
                        </View>

                        <TouchableOpacity style={{
                            backgroundColor: 'white', borderRadius: 10, marginHorizontal: 16,
                            marginVertical: 7, flexDirection: 'row', borderWidth: 2, borderColor: merchant?.color
                        }}
                            onPress={() => navigation.navigate('finance')}>
                            <View style={{ flex: 1, flexDirection: 'column', marginLeft: 14, marginTop: 5, marginBottom: 8 }}>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 24, flex: 1 }}>Doanh thu</Text>
                                <View style={{ flexDirection: 'row' }}>
                                    <View style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>DT realtime tháng</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>DT xuất bến tháng</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>DT realtime ngày</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>DT xuất bến ngày</Text>
                                    </View>
                                    <View style={{ flexDirection: 'column', marginLeft: 8 }}>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.turnover?.revenue_realtime_month?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.turnover?.revenue_export_months?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.turnover?.revenue_realtime_day?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.turnover?.revenue_export_days?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                    </View>
                                </View>
                            </View>
                            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                <Image source={images.finance} style={{ width: 100, height: 100, margin: 8, resizeMode: 'contain' }} />
                            </View>
                        </TouchableOpacity>

                        <TouchableOpacity style={{
                            backgroundColor: 'white', borderRadius: 10, marginHorizontal: 16,
                            marginVertical: 7, flexDirection: 'row', borderWidth: 2, borderColor: merchant?.color
                        }}
                            onPress={() => navigation.navigate('customer')}>
                            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                <Image source={images.review} style={{ width: 100, height: 100, margin: 8, resizeMode: 'contain' }} />
                            </View>
                            <View style={{ flex: 1, flexDirection: 'column', marginRight: 14, marginTop: 5, marginBottom: 8 }}>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 24, flex: 1, textAlign: 'right' }}>Khách hàng</Text>
                                <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                                    <View style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Khách hàng tháng</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Khách hàng mới</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Vé realtime tháng</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Vé realtime ngày</Text>
                                    </View>
                                    <View style={{ flexDirection: 'column', marginLeft: 8 }}>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.passenger?.passenger_month?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.passenger?.passenger_new?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.passenger?.ticket_realtime_month?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.passenger?.ticket_realtime_day?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>

                                    </View>
                                </View>
                            </View>
                        </TouchableOpacity>

                        <TouchableOpacity style={{
                            backgroundColor: 'white', borderRadius: 10, marginHorizontal: 16,
                            marginVertical: 7, flexDirection: 'row', borderWidth: 2, borderColor: merchant?.color
                        }}
                            onPress={() => navigation.navigate('process')}>
                            <View style={{ flex: 1, flexDirection: 'column', marginLeft: 14, marginTop: 5, marginBottom: 8 }}>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 24, flex: 1 }}>Vận hành</Text>
                                <View style={{ flexDirection: 'row' }}>
                                    <View style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Số chuyến tháng</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Xuất bến tháng</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Số chuyến ngày</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Xuất bến ngày</Text>
                                    </View>
                                    <View style={{ flexDirection: 'column', marginLeft: 8 }}>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.operate?.countTripOfMonth?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.operate?.countTripExportMonth?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.operate?.countTripOfDay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.operate?.countTripExportDay?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                    </View>
                                </View>
                            </View>
                            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                <Image source={images.analytics} style={{ width: 100, height: 100, margin: 8 }} />
                            </View>
                        </TouchableOpacity>

                        {/* <TouchableOpacity style={{
                            backgroundColor: 'white', borderRadius: 10, marginHorizontal: 16,
                            marginVertical: 7, flexDirection: 'row', borderWidth: 2, borderColor: merchant?.color
                        }}
                            onPress={() => navigation.navigate('team')}>
                            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                <Image source={images.resume} style={{ width: 100, height: 100, margin: 8 }} />
                            </View>
                            <View style={{ flex: 1, flexDirection: 'column', marginRight: 14, marginTop: 5, marginBottom: 8 }}>
                                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 24, flex: 1, textAlign: 'right' }}>Nhân sự</Text>
                                <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                                    <View style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Tổng số nhân sự</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Tổng số lái xe</Text>
                                        <Text style={{ color: colors.text_sub, fontFamily: 'Nunito_700Bold' }}>Nhân sự mới</Text>
                                    </View>
                                    <View style={{ flexDirection: 'column', marginLeft: 8 }}>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.hrm?.hrm_total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.hrm?.hrm_driver?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}>{data?.hrm?.hrm_new?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                    </View>
                                </View>
                            </View>
                        </TouchableOpacity> */}
                        <View style={{ height: 7 }} />
                    </> : (
                        !refreshing ? <View style={{ marginTop: 80, flexDirection: 'column', alignItems: 'center' }}>
                            <Image source={images.server_error} style={{ width: 200, height: 200 }} />
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginTop: 24, fontSize: 18 }}>Đã có lỗi xảy ra</Text>
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Vui lòng ấn nút bên dưới để thử lại</Text>
                            <TouchableOpacity onPress={onRefresh}>
                                <Image source={images.refresh} style={{ width: 40, height: 40, marginTop: 16 }} />
                            </TouchableOpacity>
                        </View> : null
                    )
                }
            </ScrollView>
        </View>
    );
})